import { apiUrl } from '../config/api';
import { getStoredUser, setStoredUser } from './auth';

/** Load the signed-in user profile (including company name) from the API. */
export async function refreshCurrentUser(email = getStoredUser()?.email) {
  if (!email) return null;
  try {
    const res = await fetch(apiUrl('/api/users/me'), {
      headers: { 'X-User-Email': email },
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data.user) return null;
    setStoredUser(data.user);
    return data.user;
  } catch {
    return null;
  }
}
